<template>
    <div class="col-12">
        <div class="input-group mb-3">
            <input aria-describedby="basic-addon1" aria-label=""
                   class="form-control col-form-label-lg"
                   name="search" placeholder="Rechercher" type="text" v-model="query" v-on:input="search(false)">
            <div class="input-group-append">
                <button class="btn btn-primary" dusk="search_button" type="button" v-on:click="search(false)">Rechercher
                </button>
            </div>
        </div>
        <small class="form-text text-muted">
            Nombre de résultats affichés : <i class='fas fa-circle-notch fa-spin' v-if="loading"></i> <span
                v-if="!loading">{{ (response['total'] > 0) ? '1 - ' + response['to'] +
            '(total: ' + response['total'] + ')' : '0'}}</span>
        </small>
        <div class="row mt-5">
            <div class="col-12 col-md-3">
                <h6>Clients:</h6>
                <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in companies">
                    <input :disabled="loading" class="custom-control-input" type="checkbox"
                           v-bind:checked="!badge['disabled']" v-bind:id="index" v-bind:name="badge['id']"
                           v-on:click="inverseBadge(index)"/>
                    <label class="custom-control-label" v-bind:for="index">
                        {{ badge['name']}}, {{ badge['location'] }}
                    </label>
                </div>
            </div>
            <div class="col-12 col-md-9">
                <div class="table-responsive">
                    <table class="table table-hover" id="deployments">
                        <thead>
                        <tr>
                            <th v-for="(column, index) in columns" v-on:click="sortBy(index)">
                                <span style="cursor: pointer;">{{ column['name'] }}</span>
                                <span v-if="column['orderable']">
                            <i class="fas fa-arrow-down fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === 1}"></i>
                            <i class="fas fa-arrow-up fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === -1}"></i>

                        </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading && page === 1">
                            <td colspan="7"><i class="fas fa-circle-notch fa-spin"></i> Chargement des données en cours
                            </td>
                        </tr>
                        <tr v-if="data.length === 0 && loading === false">
                            <td colspan="7">Aucun modèle ne correspond à vos critères de recherche.</td>
                        </tr>
                        <tr v-for="entry in filteredResults" v-if="!loading || page > 1">
                            <th scope="row">{{ entry['id']}}</th>
                            <td>{{ entry['label'] }}</td>
                            <td>{{ entry['need_internet']}}</td>
                            <td>{{ entry['restricted'] }}</td>
                            <td><a v-bind:href="entry['id'] + '/edit'">Détails</a></td>
                        </tr>
                        <tr v-if="!loading && data.length !== 0 && response['last_page'] > page">
                            <td colspan="6" id="loadMore" v-on:click="loadMore">Charger plus ...</td>
                        </tr>
                        <tr v-if="loading && data.length !== 0 && response['last_page'] > page">
                            <td colspan="6"><i class="fas fa-circle-notch fa-spin"></i> Chargement des prochains
                                résultats en cours
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['companies_id'],
        data: function () {
            return {
                page: 1,
                response: [],
                sortCell: '',
                loading: true,
                query: '',
                data: [],
                companies: [],
                columns: {
                    'id': {
                        name: '#',
                        db_name: 'id',
                        orderable: true,
                        sortDirection: 1,
                        type: 'number'
                    },
                    'name': {
                        name: 'Nom',
                        db_name: 'label',
                        orderable: true,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'need_internet': {
                        name: 'Nécéssite internet',
                        db_name: 'need_internet',
                        orderable: true,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'restricted': {
                        'name': 'Restreint',
                        db_name: 'restricted',
                        orderable: true,
                        sortDirection: 1,
                        type: 'text',
                    },
                    'details': {
                        name: 'Détails',
                        db_name: '',
                        orderable: false,
                        sortDirection: 1,
                        type: ''
                    },
                },
            }
        },
        filters: {
            displayDate: function (value) {
                if (value === null) return '';
                var parts = value.split(' ')[0].split('-');
                var date = new Date(parts[0], parts[1], parts[2]);
                return ('0' + date.getDate()).slice(-2) + '/' + ('0' + date.getMonth()).slice(-2) + '/' + date.getFullYear();
            },
        },
        computed: {
            filteredResults: function () {
                var data = this.data;
                if (this.sortCell) {
                    var cell = this.columns[this.sortCell];
                    var direction = cell['sortDirection'];
                    if (cell['type'] === 'date') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = new Date(a[cell['db_name']]);
                            var b1 = new Date(b[cell['db_name']]);

                            return (a1.getTime() === b1.getTime()) ? 0 : ((a1.getTime() > b1.getTime()) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'number') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'text') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    }
                }
                return data;
            },
            badgeClass: function (badge) {
                return {
                    'badge-success': badge['type'] === 'equipment',
                    'badge-danger': badge['type'] === 'date'
                }
            }
        },
        created: function () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted: function () {
            axios.post('/admin/companies/list?smartcity', {})
                .then(response => {
                    this.companies = response.data;
                    this.companies.forEach(function (item) {
                        if (this.companies_id.length > 0) {
                            if (this.companies_id.indexOf(item['id']) < 0) {
                                item['disabled'] = true;
                            } else {
                                item['disabled'] = false;
                            }
                        } else {
                            item['disabled'] = false;
                        }

                    }.bind(this));
                    this.search();
                });
        },
        methods: {
            handleScroll: function () {
                if (!this.loading) {
                    if (document.getElementById('loadMore') != null && this.isInViewport(document.getElementById('loadMore'))) {
                        this.loadMore();
                    }
                }
            },
            isInViewport: function (elem) {
                var bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            sortBy: function (index) {
                if (this.columns[index]['orderable'] === true) {
                    this.sortCell = index;
                    this.columns[index]['sortDirection'] *= -1;
                }
            },
            inverseBadge: function (index) {
                this.companies[index]['disabled'] = !this.companies[index]['disabled'];
                this.$forceUpdate();
                this.search();
            },
            loadMore: function () {
                this.page++;
                this.search(true);
            },
            search: function (next_page = false) {
                this.loading = true;
                if (!next_page) {
                    this.page = 1;
                    this.data = [];
                }
                var companies_id = [];
                this.companies.forEach(function (item) {
                    if (!item['disabled']) {
                        companies_id.push(item['id']);
                    }
                });
                axios
                    .post('/smartcity/admin/models/search', {
                        query: this.query,
                        companies: companies_id,
                        page: this.page,
                    })
                    .then(response => {
                        if (next_page) {
                            this.data = this.data.concat(response.data.data);
                        } else {
                            this.data = response.data.data;
                        }
                        this.response = response.data;
                        this.loading = false;
                    });

            },
        }
    }
</script>
